import type { FC } from 'react';

import React from 'react';
import { Star } from '@phosphor-icons/react';

import { formatNumber } from 'src/utils/common';

import { Stack } from 'src/components/themed/Stack';
import { Typography } from 'src/components/themed/Typography';

interface XpBalanceCardProps {
  balance: number;
}

export const XpBalanceCard: FC<XpBalanceCardProps> = ({ balance }) => (
  <Stack
    gap={2}
    p={4}
    alignItems="center"
    justifyContent="center"
    style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      borderRadius: '16px',
      minHeight: '140px',
    }}
  >
    <Stack flexDirection="row" alignItems="center" gap={1}>
      <Star size={32} color="white" weight="fill" />
      <Typography variant="title2" fontWeight="700" color="white">
        XP Balance
      </Typography>
    </Stack>
    <Typography variant="title1" fontWeight="700" color="white">
      {formatNumber(balance, true)}
    </Typography>
  </Stack>
);
